import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { ModalType } from '~/types';

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    position: fixed;
    z-index: ${theme.zIndex.modal};
    /* top: 49.5%;
    left: 49.5%; */
    top: 50%;
    left: 50%;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    min-width: 280px;
    max-width: 320px;
    min-height: 180px;
    overflow: hidden;
    transform: translate(-50%, -50%) translate(-0.5px, -0.5px);
    border-radius: 16px;
    background: ${theme.backgroundColor.bg_light_5_alpha};
    will-change: translate;
    backdrop-filter: blur(50px);
  `}
`;

export const Background = styled.div`
  ${({ theme }) => css`
    display: flex;
    position: fixed;
    z-index: ${theme.zIndex.background};
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    border-radius: 16px;
    background: ${theme.backgroundColor.base};
  `}
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px;
  gap: 16px;
`;

export const TitleBox = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
  `}
`;

export const Title = styled.strong`
  ${({ theme }) => css`
    width: calc(100% - 44px);
    margin-left: 10px;
    ${theme.fontStyle.title.section20_bold}
    color: ${theme.content.content_light_1};
  `}
`;

export const DescBox = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 4px;
  `}
`;

export const Desc = styled.p`
  ${({ theme }) => css`
    ${theme.fontStyle.text.body16_medium}
    color: ${theme.content.content_light_2};
  `}
`;

export const Password = styled.div`
  ${({ theme }) => css`
    width: 100%;
    height: 44px;
    border-radius: 8px;
    background: ${theme.backgroundColor.bg_dark_2};

    & > input {
      display: block;
      width: 100%;
      padding: 12px;

      ${theme.fontStyle.text.body16_medium}
      color: ${theme.content.content_light_1};

      &::placeholder {
        color: ${theme.content.content_light_5};
      }
    }
  `}
`;

export const ErrorMsg = styled.div`
  ${({ theme }) => css`
    ${theme.fontStyle.text.caption_medium}
    color: ${theme.themeColor.negative};
  `}
`;

export const ButtonWrapper = styled.div<{ type: ModalType }>`
  ${({ theme, type }) => css`
    display: flex;
    justify-content: center;
    ${type !== 'single' && `border-top: 1px solid ${theme.stroke.stroke_1}`}
  `}
`;

export const SingleButtonBox = styled.div`
  ${({ theme }) => css`
    width: 100%;
    height: 100%;
    padding: 0 24px 24px;

    & > button {
      display: block;
      width: 100%;
      height: 100%;
      border: 1px solid ${theme.stroke.stroke_1};
      border-radius: 24px;
      background: ${theme.backgroundColor.bg_light_5_alpha};

      ${theme.fontStyle.text.body18_medium}
      color: ${theme.content.content_light_1};
    }
  `}
`;

export const CloseButton = styled.button`
  ${({ theme }) => css`
    position: absolute;
    top: 0;
    right: 0;
    padding: 15px;
  `}
`;
